export interface IRegulatedMarket {
  id: number;
  shortCut: string;
  region: string;
  regionCode: string;
  format: string;
  pattern: string;
  examples: string[];
}

export const resolveMaRegionName = (region: string, maNumbersConfig?: IRegulatedMarket[]) => {
  const matchingConfig = maNumbersConfig?.find((item) => item.regionCode?.toUpperCase() === region?.toUpperCase());

  return matchingConfig?.region ?? region;
};
